export default __webpack_public_path__ + "static/media/icon-phonenumber.dcfa0113.svg";